// Import all views here
import exampleView from './views/example';
import homeView from './views/home';
import aboutUsView from './views/about-us';
import contactView from './views/contact';
import partnersView from './views/partners';
import projectsView from './views/projects';

export default [exampleView, homeView, aboutUsView, contactView, partnersView, projectsView];
